import React, { useEffect } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import Button from "../component-lib/Molecules/button/Button";
import { CUSTOM_lABEL_STYLE } from "../screens/patient-screen/visit-flow/constant";
import Heading from "../component-lib/Atoms/heading/EventEHRHeading";
import useDeviceType from "../custom-hooks/DeviceType";
import SelectDropdown from "../component-lib/Atoms/Select/Select";
import {
  CLEAR_EMS_FORM_DATA,
  TYPE_OF_TRANSFER_DISPOSITION_DATA,
} from "./constants";
import { useDispatch, useSelector } from "react-redux";
import { getFacilities } from "../screens/patient-screen/patientSaga";
import { componentKey } from "../screens/patient-screen/patientSlice";
import Input from "../component-lib/Atoms/Input/Input";

interface ClearEMSFormProps {
  getFormData: (data: any) => void;
}

export default function ClearEMSForm({ getFormData }: ClearEMSFormProps) {
  const commonGridStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "14px",
  };

  const { facilityData, tempVisitData } = useSelector(
    (state: any) => state[componentKey]
  );

  const facilityDataList = facilityData?.filter((data: any) =>
    data?.name?.toLowerCase()?.includes("jamboree")
  );
  const departmentList = facilityDataList[0]?.department?.map((data: any) => ({
    label: data?.name,
    value: data?.id,
  }));

  const dispatch = useDispatch();
  const deviceType = useDeviceType();

  const validationSchema = Yup.object().shape({
    [CLEAR_EMS_FORM_DATA?.INCIDENT_LOCATION]: Yup.string().required(
      "Incident location is required"
    ),
    [CLEAR_EMS_FORM_DATA.INJURY_LOCATION]: Yup.string().required(
      "Injury location is required"
    ),
    [CLEAR_EMS_FORM_DATA?.INJURY_TYPE]: Yup.string().required(
      "Injury type is required"
    ),
    [CLEAR_EMS_FORM_DATA?.WITNESS_NAME]: Yup.string().required(
      "Witness name is required"
    ),
  });

  return (
    <Formik
      initialValues={{
        [CLEAR_EMS_FORM_DATA?.INCIDENT_LOCATION]: `${tempVisitData?.incidentlocation || ""}`,
        [CLEAR_EMS_FORM_DATA?.INJURY_LOCATION]: `${tempVisitData?.injuryLocation || ""}`,
        [CLEAR_EMS_FORM_DATA?.INJURY_TYPE]: `${tempVisitData?.injuryType || ""}`,
        [CLEAR_EMS_FORM_DATA?.WITNESS_NAME]: `${tempVisitData?.witnessName || ""}`,
      }}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={(values, { setSubmitting }) => {
        try {
          getFormData(values);
        } catch (error) {
          console.log(error);
        } finally {
          setSubmitting(false); // Reset submitting state
        }
      }}
    >
      {({
        errors,
        values,
        touched,
        isValid,
        dirty,
        setFieldValue,
        handleBlur,
        handleSubmit,
      }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <Heading
              title="Incident Details"
              customStyle={{
                fontSize: "16px",
                fontWeight: 500,
                fontFamily: "Inter",
                color: "rgb(57, 57, 57)",
              }}
            />
            <div
              className="h-full flex flex-col justify-between gap-6 pt-4"
              style={{
                height: deviceType === "mobile" ? "40vh" : "fit-content",
                overflow: "auto",
              }}
            >
              <div
                style={{
                  ...commonGridStyle,
                  rowGap: "21px",
                  columnGap: "16px",
                }}
              >
                <Input
                  textFieldLabel="Injury Type"
                  //   isStarPresent={true}
                  maxLength={100}
                  name={CLEAR_EMS_FORM_DATA.INJURY_TYPE}
                  value={values[CLEAR_EMS_FORM_DATA.INJURY_TYPE]}
                  onChangeCb={(e) => {
                    setFieldValue(
                      CLEAR_EMS_FORM_DATA.INJURY_TYPE,
                      e.target.value
                    );
                  }}
                  size="small"
                  onBlur={handleBlur}
                  error={
                    touched[CLEAR_EMS_FORM_DATA.INJURY_TYPE] &&
                    Boolean(errors[CLEAR_EMS_FORM_DATA.INJURY_TYPE])
                  }
                  helperText={
                    touched[CLEAR_EMS_FORM_DATA.INJURY_TYPE]
                      ? errors[CLEAR_EMS_FORM_DATA.INJURY_TYPE]
                      : undefined
                  }
                />

                <Input
                  textFieldLabel="Injury Location"
                  //   isStarPresent={true}
                  maxLength={100}
                  name={CLEAR_EMS_FORM_DATA.INJURY_LOCATION}
                  value={values[CLEAR_EMS_FORM_DATA.INJURY_LOCATION]}
                  onChangeCb={(e) => {
                    setFieldValue(
                      CLEAR_EMS_FORM_DATA.INJURY_LOCATION,
                      e.target.value
                    );
                  }}
                  size="small"
                  onBlur={handleBlur}
                  error={
                    touched[CLEAR_EMS_FORM_DATA.INJURY_LOCATION] &&
                    Boolean(errors[CLEAR_EMS_FORM_DATA.INJURY_LOCATION])
                  }
                  helperText={
                    touched[CLEAR_EMS_FORM_DATA.INJURY_LOCATION]
                      ? errors[CLEAR_EMS_FORM_DATA.INJURY_LOCATION]
                      : undefined
                  }
                />
                <Input
                  textFieldLabel="Witness Name"
                  //   isStarPresent={true}
                  maxLength={100}
                  name={CLEAR_EMS_FORM_DATA.WITNESS_NAME}
                  value={values[CLEAR_EMS_FORM_DATA.WITNESS_NAME]}
                  onChangeCb={(e) => {
                    setFieldValue(
                      CLEAR_EMS_FORM_DATA.WITNESS_NAME,
                      e.target.value
                    );
                  }}
                  size="small"
                  onBlur={handleBlur}
                  error={
                    touched[CLEAR_EMS_FORM_DATA.WITNESS_NAME] &&
                    Boolean(errors[CLEAR_EMS_FORM_DATA.WITNESS_NAME])
                  }
                  helperText={
                    touched[CLEAR_EMS_FORM_DATA.WITNESS_NAME]
                      ? errors[CLEAR_EMS_FORM_DATA.WITNESS_NAME]
                      : undefined
                  }
                />

                <Input
                  textFieldLabel="Incident Location"
                  //   isStarPresent={true}
                  maxLength={100}
                  name={CLEAR_EMS_FORM_DATA.INCIDENT_LOCATION}
                  value={values[CLEAR_EMS_FORM_DATA.INCIDENT_LOCATION]}
                  onChangeCb={(e) => {
                    setFieldValue(
                      CLEAR_EMS_FORM_DATA.INCIDENT_LOCATION,
                      e.target.value
                    );
                  }}
                  size="small"
                  onBlur={handleBlur}
                  error={
                    touched[CLEAR_EMS_FORM_DATA.INCIDENT_LOCATION] &&
                    Boolean(errors[CLEAR_EMS_FORM_DATA.INCIDENT_LOCATION])
                  }
                  helperText={
                    touched[CLEAR_EMS_FORM_DATA.INCIDENT_LOCATION]
                      ? errors[CLEAR_EMS_FORM_DATA.INCIDENT_LOCATION]
                      : undefined
                  }
                />
              </div>
            </div>

            {/* ACTION BUTTON */}
            <div className="mt-9 text-end">
              <Button
                // disabled={!isValid} // Button disabled if form is invalid or submitting
                type="submit"
                label="Submit"
                variant="contained"
                onClickCb={() => {}}
                style={{
                  padding: "8px 55px",
                  fontSize: "16px",
                }}
              ></Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}
